<template>
  <div>
    <el-container>
      <el-header>
        <el-row type="flex" class="row-bg" justify="space-between">
          <el-col :span="6">
            <div class="welcome">{{$t('hi')}}，{{$t('welcomeTo')}} {{this.$store.state.config.shop_name}}</div>
          </el-col>
          <el-col :span="10" type="flex" class="row-right">
            <div class="flex-nav">
              <template v-if="getUser.id">
                <div
                  class="user-nav"
                  @mouseover="showUserCenter=true"
                  @mouseleave="showUserCenter=false"
                >
                  <span class="el-dropdown-link" v-if="user">
                    <!-- {{ getUser.email || getUser.nickname || getUser.username || getUser.mobile}} -->
					My Account
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-collapse-transition>
                    <ul v-show="showUserCenter">
                      <li class="drop-item" v-for="(item,index) in userNavArr" :key="index">
                        <router-link :to="{path:item.route}">{{item.title}}</router-link>
                      </li>
                      <li class="drop-item" @click="exit">{{$t('loginOut')}}</li>
                    </ul>
                  </el-collapse-transition>
                </div>
              </template>

              <template v-else>
                <router-link :to="{name:'register'}" class="nav-item">{{$t('register')}}</router-link>
                <router-link :to="{name:'login'}" class="nav-item"><!-- {{$t('login')}} -->My Account <span class="my"></span></router-link>
              </template>

               <router-link :to="{name:'help'}" class="nav-item">Customer service<!-- {{$t('helpCenter')}} --></router-link>

              <!-- <div  class="nav-item shop-cart"  @mouseover="cartShow=true" 
                @mouseleave="cartShow=false">
                {{$t('mobileShop')}}  <i class="el-icon-arrow-down"></i>
                <div class="cart-main" v-show="cartShow" @mouseover="cartShow=true">
                  <img :src="cartImg" alt="">
                </div>
              </div> -->
              <!-- <div  class="nav-item shop-cart"  @mouseover="cartShow=true" @mouseleave="cartShow=false"  :class="{'active':cartNums>0}">
                <router-link to="/cart">
                  <i class="icon iconfont iconcart"></i>购物车
                  <span class="cart-num">（{{cartNums}}）</span>
                </router-link>
                <div class="cart-main" v-show="cartShow" @mouseover="cartShow=true">
                  <div class="loading" v-show="cartList.length==0">
                    <div class="loader">购物车快饿瘪了 T.T</div>
                  </div>
                  <div class="cart-block" v-show="cartList.length>0">
                    <ul>
                      <li
                        v-for="(item,index) in cartList"
                        :key="index"
                        @mouseover="hoverIndex=index"
                      >
                        <router-link
                          :to="{name:'detail',params:{goodsId:item.products.goods_id}}"
                          class="img-link"
                        >
                          <img :src="item.products.image_path" :alt="item.products.name">
                        </router-link>
                        <div class="title">
                          <router-link
                            :to="{name:'detail',params:{goodsId:item.products.goods_id}}"
                            class="img-link"
                          >{{item.products.name}}</router-link>
                        </div>
                        <div class="pn">
                          <span class="price">{{item.products.price}}元</span>
                          <span class="icon iconfont iconchenghao"></span>
                          <span class="num">{{item.nums}}</span>
                        </div>
                        <div class="del">
                          <div
                            class="del-icon"
                            v-show="hoverIndex==index"
                            @click="removeShop(index,item.id)"
                          >
                            <span class="icon iconfont iconchenghao"></span>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <div class="cart-bootom">
                      <div class="cart-m">
                        <span class="total-num">共{{cartNums}}件商品</span>
                        <span class="total-price">
                          <span class="b-price">{{goodsTotalPrice}}</span> 元
                        </span>
                        <div class="go-cart">
                          <router-link to="/cart">去购物车结算</router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->

              
            </div>
          </el-col>
        </el-row>
      </el-header>
    </el-container>
    <main-top />
  </div>
</template>
<script>

import MainTop from "@/components/common/MainTop.vue";

import { mapState, mapActions } from "vuex";
export default {
  name: "Header",
  props: {},
  components: {
    MainTop
  },
  data() {
    return {
      showUserCenter: false,
      userNavArr: [
        {
          title: this.$t('center'),
          route: "/center"
        },
        {
          title: this.$t('myOrder'),
          route: "/center/myOrder"
        },
        {
          title: this.$t('collection'),
          route: "/center/favourite"
        }
      ],
      cartList: [],
      goodsTotalPrice: 0, //购物车总价
      cartShow: false,
      cartImg: '',

      hoverIndex: -1,
      getUser: {}
    };
  },
  created() {
    let timeS = new Date().getTime()
    this.cartImg = 'https://www.sanlida.cn/Storage/master/QRCode/www.sanlida.cn_vshop.png?' + timeS
    if (this.$storage.get("userToken")) {
      this.getCartNums();
      this.getCartList();

      const _this = this
        this.$api.userInfo({}).then( res =>{
          _this.getUser =  res.data
      })
    }
  },
  watch: {
    cartNums(newVal) {
      this.getCartList();
    }
  },
  computed: {
    ...mapState({
      user: state => state.userInfo,
      cartNums: "cartNums",
      shopMenu: state => state.shopMenu
    }),
    userInfo() {
      if (this.$storage.get("userToken")) {
        
        // return this.user && JSON.stringify(this.user) != "{}"
        //   ? this.user
        //   : this.$storage.get("userInfo")
        //   ? this.$storage.get("userInfo")
        //   : "";
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapActions(["getUserInfo", "getCartNumsAction"]),
    // 获取购物车数量
    getCartNums() {
      this.$api.getCartNum().then(res => {
        if (res.status) {
          this.getCartNumsAction(res.data);
        }
      });
    },
    //删除购物车
    removeShop(index, id) {
      this.cartList.splice(index, 1);
      let data = {
        ids: id
      };
      this.$api.removeCart(data).then(res => {
        if (res.status) {
          this.getCartList();
          this.getCartNums();
        }
      });
    },
    //获取购物车列表
    getCartList() {
      this.$api.cartListSelectAll().then(res => {
        if (res.status) {
          this.goodsTotalPrice = res.data.amount;
          this.cartList = res.data.list;
        }
      });
    },
    exit() {
      this.$storage.remove("userToken");
      this.$storage.remove("userInfo");
      this.$storage.remove("areaList");

      this.getUserInfo({});
      if (this.$route.name == "home") {
        this.$router.go(0);
      } else {
        this.$router.replace("/");
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
.el-container {
  width: 100%;
  height: 40px;
  background: #f9f9f9;
  border-bottom: 1px solid #e5e5e5;
  .el-header {
    width: 1226px;
    height: 40px;
    margin: 0 auto;
    padding: 0;
    font-size: 12px;
    .row-bg {
      height: 100%;
      color: #fff;
      .el-col {
        height: 40px;
        line-height: 40px;
        .welcome {
          font-size: 13px;
          color: #000;
        }
      }
      .row-right {
        align-items: center;
        .flex-nav {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          .sep {
            color: #424242;
            margin: 0 3px;
          }
          .nav-item {
			.my{
				width:20px;
				height:22px;
				background:url("~@/assets/icon/my.png") no-repeat left top 4px;
				display:inline-block;
			}
            display: block;
            padding: 0 17px;
            text-align: center;
            color: #000;
            font-size: 13px;
            &:hover {
              color: $theme-color;
            }
            &.shop-cart {
              height: 40px;
              line-height: 39px;
              text-align: center;
              padding: 0 14px;
              position: relative;
              transition: all 0.3s;
              cursor: pointer;
              border: 1px solid transparent ;
              a {
                display: block;
              }
              &.active {
                background: $theme-color;
                color: #fff;
              }
              .icon {
                margin-right: 3px;
              }
              &:hover {
                border: 1px solid #ebebeb ;
                color: $theme-color;
                background: #fff;
                .el-icon-arrow-down {
                  transform: rotateZ(180deg);
                }

              }
              .cart-main {
                position: absolute;
                right: 0;
                top: 40px;
                z-index: 31;
                width: 260px;
                padding: 15px 0px 0;
                color: #424242;
                background: #fff;
                border: 1px solid #e0e0e0;
                border-top: 0;
                box-sizing: border-box;
                img {
                  width: 100%;
                }
                .loading {
                  margin: 5px 20px 20px;
                  text-align: center;
                  .loader {
                    margin: 0 auto;
                  }
                }
                .cart-block {
                  position: relative;
                  ul {
                    min-height: 0;
                    max-height: 410px;
                    overflow-y: auto;
                    padding: 0 14px;
                    li {
                      height: 80px;
                      display: flex;
                      align-items: center;
                      &:not(:last-child) {
                        border-bottom: 1px solid $border;
                      }
                      .img-link {
                        display: block;
                        img {
                          width: 60px;
                          height: 60px;
                          object-fit: contain;
                          float: left;
                        }
                      }
                      .title {
                        float: left;
                        width: 95px;
                        height: 40px;
                        overflow: hidden;
                        text-align: left;
                        margin-left: 5px;
                        &:hover {
                          color: $theme-color;
                        }
                        a {
                          display: block;
                          height: 40px;
                        }
                      }
                      .pn {
                        flex: 1;
                        .icon {
                          font-size: 12px;
                        }
                      }
                      .del {
                        width: 30px;
                        cursor: pointer;
                        .del-icon {
                          .icon {
                            font-size: 16px;
                            color: #b0b0b0;
                          }
                        }
                        &:hover {
                          .del-icon .icon {
                            color: #424242;
                            font-weight: 600;
                          }
                        }
                      }
                    }
                  }
                  .cart-bootom {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    height: 40px;
                    padding: 15px 0px;
                    background: #fafafa;
                    z-index: 999;
                    .cart-m {
                      width: 100%;
                      height: 40px;
                      margin: 14px;
                      position: relative;
                      .total-num {
                        position: absolute;
                        top: 0;
                        left: 0px;
                        display: block;
                        height: 14px;
                        line-height: 1;
                        font-size: 10px;
                      }
                      .total-price {
                        display: block;
                        color: $theme-color;
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        height: 24px;
                        line-height: 1;
                        .b-price {
                          font-size: 24px;
                          font-weight: 550;
                        }
                      }
                      .go-cart {
                        position: absolute;
                        right: 0;
                        top: 0;
                        width: 132px;
                        height: 40px;
                        background: $theme-color;
                        color: #fff;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
.user-nav {
  // width: 120px;
  cursor: pointer;
  position: relative;
  text-align: center;
  transition: all 0.2s;
  color: #b3b3b3;
  padding: 0 10px;
  &:hover {
    background: #fff;
    color: $theme-color;
  }
  .el-dropdown-link {
    display: block;
    width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
  }
  ul {
    position: absolute;
    top: 40px;
    left: 0;
    width: 100%;
    z-index: 9999;
    background: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    .drop-item {
      width: 100%;
      font-size: 12px;
      color: #757575;
      transition: all 0.2s;
      a {
        display: block;
      }
      &:hover {
        color: $theme-color;
        background: #f5f5f5;
      }
    }
  }
}
</style>